// extracted by mini-css-extract-plugin
export default {"chipsContainer":"Chips_chipsContainer__qfL-c","text":"Chips_text__a64ME","imageWrapper":"Chips_imageWrapper__2+GKJ"};